import React, { useState, useEffect } from "react";
import { Mensaje } from "../../mensajes2";
import { Dimmer } from "../../spinner";
import useTable from "../../useTableR";
import { ModalContribuyenteLicores } from "./modalContribuyentesLicores";
import axios from "axios";
import moment from "moment";
import { SearchInput } from "../../../ui/inputs/Input";

const headCells = [
  {
    id: "idcomercio",
    label: "CODIGO",
    width: "10px",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    fontSize: "10px",
    color: "white",
  },
  {
    id: "ritm",
    label: "RITM",
    width: "80px",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    fontSize: "10px",
    color: "white",
  },
  {
    id: "rif",
    label: "RIF",
    width: "80px",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    fontSize: "10px",
    color: "white",
  },
  {
    id: "nombre",
    label: "NOMBRE",
    width: "300px",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    fontSize: "10px",
    color: "white",
  },
  {
    id: "reprelegal",
    label: "CEDULA RESPONSABLE",
    width: "150px",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    fontSize: "10px",
    color: "white",
  },
  {
    id: "accion",
    label: "OPCIONES",
    width: "180px",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    fontSize: "10px",
    color: "white",
  },
];

function TablaContribuyenteLicores(props) {
  let op = require("../../../../src/modulos/datos");
  let token = localStorage.getItem("jwtToken");
  const [activate, setActivate] = useState(false);
  const [operacion, setOperacion] = useState(0);
  const [comercio, setComercio] = useState();
  const [persona, setPersona] = useState();

  const [permiso] = useState();
  const [records, setRecords] = useState([]);
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const [mostarModal, setMostrarModal] = useState(false);
  const [indole, setIndole] = useState();
  const [deuda, setDeuda] = useState();
  const [historico, setHistorico] = useState();
  const [petro, setPetro] = useState();
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });

  const cerrarContri = () => {
    setMostrarModal(false);
  };

  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTable(records, headCells, filterFn);

  const handleSearch = (e) => {
    let target = e.target;

    setFilterFn({
      fn: (items) => {
        if (target.value === "") {
          return items;
        } else {
          return items.filter((x) => {
            if (
              (x.idcomercio.includes(target.value) === null
                ? ""
                : x.idcomercio.includes(target.value)) ||
              (x.ritm === null
                ? ""
                : x.ritm.toLowerCase().includes(target.value.toLowerCase())) ||
              (x.rif === null
                ? ""
                : x.rif.toLowerCase().includes(target.value.toLowerCase())) ||
              (x.nombre === null
                ? ""
                : x.nombre.toLowerCase().includes(target.value.toLowerCase()))
            ) {
              return x;
            }
          });
        }
      },
    });
  };
  const seleccionarValorPetro = () => {
    let endpoint = op.conexion + "/api/efiscal/valorpetro";
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (response.status == 200) {
          setPetro(response.data.valor);
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const seleccionarRegistros = () => {
    let campos = `idcomercio, ritm, rif, nombre, reprelegal`;
    let nomtab = "comercio";
    let orden = "idcomercio desc";
    let endpoint =
      op.conexion +
      `/api/comun/seleccionaregistros?campos=${campos}&nomtab=${nomtab}&orden=${orden}`;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setRecords(response.data);
        }
        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const seleccionarRegistro = (opti, idcomercio) => (e) => {
    e.preventDefault();
    let campos = "*";
    let nomtab = "comercio";
    let nomid = "idcomercio";
    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${idcomercio}&nomtab=${nomtab}&nomid=${nomid}`;
    console.log(endpoint);
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setActivate(true);
          if (response.data.idcomercio > 0) {
            setComercio(response.data);
            console.log(
              "reprelegal: " + parseInt(response.data.reprelegal.trim())
            );
            if (response.data.reprelegal > 0) {
              seleccionarRegistroPersona(
                response.data,
                parseInt(response.data.reprelegal)
              );
            } else {
              setActivate(false);
              setMostrarModal(true);
            }
            setOperacion(opti);
          }
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const seleccionarRegistroPersona = (data, cedula) => {
    let campos = "*";
    let nomtab = "persona";
    let nomid = "cedula";
    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${cedula}&nomtab=${nomtab}&nomid=${nomid}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.cedula > 0) {
            setPersona(response.data);
            console.log(response.data);
            seleccionarIndoleExpendio(data);
          } else {
            seleccionarIndoleExpendio(data);
          }
          setActivate(false);
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const seleccionarIndoleExpendio = (data) => {
    let endpoint = `${op.conexion}/api/licores/indole?&id=${data.idcomercio}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setIndole(response.data);
          seleccionarDeuda(data);
          console.log(response.data);
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const seleccionarDeuda = (data) => {
    let nomtab = "licores";
    let nomid = "idcomercio";
    let endpoint = `${op.conexion}/api/licores/deudalicores?nomtab=${nomtab}&nomid=${nomid}&id=${data.idcomercio} `;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          var mm =
            response.data.fechainscripcion === null
              ? 0
              : parseInt(
                  moment.utc(response.data.fechainscripcion)
                    .format("YYYY-MM-DD")
                    .substring(5, 7)
                );
          let val,
            mon = 0.0;
          let a;
          let n, mes;
          let deuda = 0.0;
          var deu = [];
          var his = [];
          for (let i = 0; i < response.data.length; i++) {
            mon = response.data[i].monto;
            switch (mm) {
              case 1:
                mes = "ENERO";
                break;
              case 2:
                mes = "FEBRERO";
                break;
              case 3:
                mes = "MARZO";
                break;
              case 4:
                mes = "ABRIL";
                break;
              case 5:
                mes = "MAYO";
                break;
              case 6:
                mes = "JUNIO";
                break;
              case 7:
                mes = "JULIO";
                break;
              case 8:
                mes = "AGOSTO";
                break;
              case 9:
                mes = "SEPTIEMBRE";
                break;
              case 10:
                mes = "OCTUBRE";
                break;
              case 11:
                mes = "NOVIEMBRE";
                break;
              case 12:
                mes = "DICIEMBRE";
                break;
            }
            if (!response.data[i].cancelada) {
              (mon = mon * petro), 2;
              deuda = deuda + mon;
              n = mon;
              deu.push({
                anio: response.data[i].anio,
                mes: mes,
                descripcion: response.data[i].descripcion,
                monto: parseFloat(n),
              });
            } else {
              n = mon;
              his.push({
                anio: response.data[i].anio,
                mes: mes,
                descripcion: response.data[i].descripcion,
                monto: n,
                numereci:
                  response.data[i].numerorecibo !== null
                    ? response.data[i].numerorecibo
                    : " ",
                fechapago:
                  response.data[i].fechapago !== null
                    ? moment.utc(response.data[i].fechapago).format("YYYY/MM/DD")
                    : "",
              });
            }
          }
          setDeuda(deu);
          setHistorico(his);
        }
        setMostrarModal(true);
        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: "error.response.data.message",
          icono: "error",
        });
        setActivate(false);
      });
  };

  useEffect(() => {
    seleccionarRegistros();
    seleccionarValorPetro();
  }, []);

  const exitHandler = () => {
    props.setTabla(0);
  };

  return (
    <div className="col-8 m-0 p-2 border rounded">
      <div className="col-12 m-0 px-4 py-2 d-flex justify-content-between azulGradiant rounded-top text-light">
        <h3 className="fw-bold m-0">Gestion de Contribuyentes Licores</h3>
        <a onClick={exitHandler} className="text-light fw-bold fs-6">
          Salir <i className="fa fa-times ms-2"></i>
        </a>
      </div>
      <div className="col-4 m-0 my-2 p-0">
        <SearchInput className='search-input ' placeholder="Buscar" onChange={handleSearch} />
      </div>
      <div className="col-12 m-0 p-0">
        <TblContainer>
          <TblHead />

          <tbody>
            {records &&
              recordsAfterPagingAndSorting().map((item, index) => (
                <tr key={item.idcomercio} style={{ padding: "0" }}>
                  <td
                    style={{
                      fontSize: "10px",
                      textAlign: "center",
                      width: "10px",
                    }}
                  >
                    {item.idcomercio}
                  </td>
                  <td
                    style={{
                      fontSize: "10px",
                      textAlign: "center",
                      width: "80px",
                    }}
                  >
                    {item.ritm}
                  </td>
                  <td
                    style={{
                      fontSize: "10px",
                      textAlign: "center",
                      width: "80px",
                    }}
                  >
                    {item.rif}
                  </td>
                  <td
                    style={{
                      fontSize: "10px",
                      textAlign: "left",
                      width: "auto",
                    }}
                  >
                    {item.nombre}
                  </td>
                  <td
                    style={{
                      fontSize: "10px",
                      textAlign: "center",
                      width: "auto",
                    }}
                  >
                    {item.reprelegal}
                  </td>
                  <td
                    className="py-1"
                    style={{
                      fontSize: "10px",
                      textAlign: "center",
                      width: "auto",
                    }}
                  >
                    <button
                      style={{
                        pointerEvents:
                          permiso && permiso.substring(0, 1) !== "1"
                            ? "none"
                            : "",
                      }}
                      onClick={seleccionarRegistro(false, item.idcomercio)}
                      className="btn btn-sm btn-info rounded-circle"
                    >
                      <i class="fas fa-eye"></i>
                    </button>
                    <a> &nbsp; </a>
                    <button
                      style={{
                        pointerEvents:
                          permiso && permiso.substring(2, 3) !== "1"
                            ? "none"
                            : "",
                      }}
                      onClick={seleccionarRegistro(true, item.idcomercio)}
                      className="btn btn-sm btn-warning rounded-circle"
                    >
                      <i className="fa fa-edit"></i>{" "}
                    </button>
                  </td>
                </tr>
              ))}
          </tbody>
        </TblContainer>
        <TblPagination />
      </div>
      <ModalContribuyenteLicores
        show={mostarModal}
        onHideCancela={cerrarContri}
        comercio={comercio}
        operacion={operacion}
        persona={persona}
        indole={indole}
        deuda={deuda}
        historico={historico}
        petro={petro}
        onHideRenderIndole={seleccionarIndoleExpendio}
        onHideRenderDeu={seleccionarDeuda}
      />
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        }}
      />
      <Dimmer active={activate} inverted></Dimmer>
    </div>
  );
}

export default TablaContribuyenteLicores;
